export enum ECatalogue {
  OpenFilters = "openFilters",
  Filters = "filters",
  AddToFavorites = "addToFavorites",
  SearchField = "searchField",
  SortBy = "sortBy",
  CatalogTabToggle = "catalogTabToggle",
  OPEN_QUESTION_FLOW = "OPEN_QUESTION_FLOW",
  OPEN_FILTER_DIALOG = "OPEN_FILTER_DIALOG",
}

export interface ISortBy {
  value: string;
  title: string;
  sortValue: {};
}

export type CatalogueAction =
  | {
      type:
        | ECatalogue.OpenFilters
        | ECatalogue.AddToFavorites
        | ECatalogue.OPEN_QUESTION_FLOW
        | ECatalogue.OPEN_FILTER_DIALOG;
      payload: boolean;
    }
  | { type: ECatalogue.Filters; payload: string[] }
  | {
      type: ECatalogue.SearchField;
      payload: string;
    }
  | {
      type: ECatalogue.CatalogTabToggle;
      payload: string;
    }
  | { type: ECatalogue.SortBy; payload: ISortBy };

export interface CatalogueState {
  isFiltersOpen: boolean;
  isFavoritesButtonClicked: boolean;
  filters: string[];
  search: string;
  sortBy: ISortBy;
  catalogTab: string;
  openQuestionDialog: boolean;
  openFilterDialog: boolean;
}

export enum CatalogTab {
  TRACK = "track",
  ALBUM = "album",
  QUICK_FILTERS = "quickFilters",
}

export const catalogueReducer = (state: CatalogueState, action: CatalogueAction) => {
  const { type, payload } = action;
  switch (type) {
    case ECatalogue.OpenFilters:
      return {
        ...state,
        isFiltersOpen: payload,
      };
    case ECatalogue.Filters:
      return {
        ...state,
        filters: payload,
      };
    case ECatalogue.AddToFavorites:
      return {
        ...state,
        isFavoritesButtonClicked: payload,
      };
    case ECatalogue.SearchField:
      return {
        ...state,
        search: payload,
      };
    case ECatalogue.SortBy:
      return {
        ...state,
        sortBy: payload,
      };
    case ECatalogue.CatalogTabToggle:
      return {
        ...state,
        catalogTab: payload,
      };
    case ECatalogue.OPEN_QUESTION_FLOW:
      return {
        ...state,
        openQuestionDialog: payload,
      };
    case ECatalogue.OPEN_FILTER_DIALOG:
      return {
        ...state,
        openFilterDialog: payload,
      };
    default:
      return state;
  }
};
